import { Badge, Box, Button, Card, Dialog, DialogActions } from '@mui/material'
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react'
import api from '../services/api';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CreateRelatorioEspontaneo from './createRelatorioEspontaneo';
import { Avatar } from '@material-ui/core';
import ShortNome from '../utils/ShortNome';
import DateHora from '../utils/dateHora';
import TextFormatado from '../utils/TextFormatado';
import HeaderGestorConfigs from '../utils/headerGestorConfigs';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
}));
export default function Relatorios({ processoId, modelName }: { processoId: string, modelName: string }) {
    // const definicoesSistema = useSelector((state) => state.definicoesSistema.data);
    const [modal, setModal] = useState(false);
    const [addRelatorio, setAddRelatorio] = useState(false);
    const [relatorios, setRelatorios] = useState([]);
    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    const handleClose = () => {
        setModal(false);
        setAddRelatorio(false);
    }
    // relatorios
    useEffect(() => {
        api.get('/relatorios?processoId=' + processoId)
            .then(res => {
                // console.log(res)
                setRelatorios(res.data.relatorios);
            }).catch(err => '')
    }, [modal, addRelatorio, processoId]);

    // console.log(relatorios)
    // console.log(processoId)

    return (
        // relatorios.length > 0 &&
        // <VerifyPermission permissions={definicoesSistema?.servicos } permission={'solicitarNumeroDeImportador'}>
        <>
            <Card sx={{ p: 2, mb: 2, cursor: 'copy' }} onClick={() => setModal(true)}>
                Relatórios Espontâneos
                <Badge style={{ padding: 7 }} badgeContent={relatorios.length}
                    color="error"
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}>
                </Badge>
            </Card>

            <BootstrapDialog
                scroll='body'
                maxWidth={'lg'}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={!!modal}
                sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: '90%', padding: 5 } }}
            >
                <HeaderGestorConfigs title="Relatórios Espontâneos" />
                {addRelatorio ?
                    <CreateRelatorioEspontaneo
                        processoId={processoId}
                        modelName={modelName}
                        handleClose={handleClose} />
                    :
                    <>
                        {relatorios.map((relatorio: any, index) => (

                            <Accordion expanded={expanded === relatorio?._id} onChange={handleChange(relatorio?._id)}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                >
                                    <Box component="span" sx={{ width: '33%', flexShrink: 0 }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {/* {index === 0 && <Badge badgeContent="Novo" color="error" style={{ marginRight: 5 }} />} */}
                                            {index + 1}º
                                            <Avatar src={relatorio.admin?.dadosPessoais.fotoURL} style={{ marginRight: 5 }} />
                                            <Typography lineHeight={1} noWrap variant="body1">
                                                <ShortNome nome={relatorio.admin?.dadosPessoais?.nome} />
                                                <br />
                                                <small><DateHora date={relatorio?.updatedAt} /></small>
                                            </Typography>
                                        </div>
                                    </Box>
                                    <Typography component="span" sx={{ color: 'text.secondary' }}>
                                        {relatorio?.nome}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>

                                    <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', borderRadius: '4px', mb: 4 }}>
                                        <TextFormatado texto={relatorio?.descricao ?? ''} />
                                    </Box>

                                    <embed
                                        id="pdfIframerelatorioEsposta"
                                        title={`PDF Viewer`}
                                        src={relatorio?.anexo}
                                        width="100%"
                                        height="800px"
                                        style={{ border: 'none' }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        ))}

                        <br />
                        <DialogActions sx={{ p: 0 }}>
                            <Button
                                // fullWidth
                                variant="contained"
                                style={{ background: '#85287e' }}
                                onClick={() => setAddRelatorio(!addRelatorio)}
                            >
                                Adicionar Relatório
                            </Button>

                        </DialogActions>
                    </>
                }

            </BootstrapDialog>
        </>

        // </VerifyPermission> 
    )
}
